export default "__VITE_ASSET__49260b22__"